function initNotificatonBar() {
  const bar = document.querySelector('.notification-bar');
  if(!bar) return;

  const status = sessionStorage.getItem('notification-bar');
  if(status === "dismiss") {
    bar.remove();
    return;
  }

  handleDocumentContentSpace(bar);
  handleNotificationBarClose(bar);
}

function handleDocumentContentSpace(bar) {
  const rect = bar.getBoundingClientRect();
  const mainContent = document.getElementById("MainContent");
  if(!mainContent) return;

  mainContent.style.paddingTop = `${rect.height}px`;
} 

function handleNotificationBarClose(bar) {
  const button = bar.querySelector('.close-bar');
  if(!button) return;

  button.addEventListener('click', () => {
    sessionStorage.setItem('notification-bar', 'dismiss');
    bar.remove();
  });
}

window.addEventListener("DOMContentLoaded", initNotificatonBar);